var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.436 0a.434.434 0 0 0-.303.746l4.253 4.253L.133 9.253a.434.434 0 0 0 .602.626l.012-.012L5 5.613l4.253 4.254a.434.434 0 1 0 .626-.603l-.012-.011-4.253-4.254L9.867.746a.434.434 0 1 0-.614-.614L5 4.385.747.132A.434.434 0 0 0 .436 0",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.56b0a3491bf4af705b82e38ea130d5dc.svg";
export { ForwardRef as ReactComponent };